// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"53c75704","222":"cd5fa6f6","512":"fe8efb16","644":"fc50ff6b","714":"cb39c832","761":"09c28e02","787":"5c4750d6","830":"7d93c874","863":"b6ef8396","895":"5f59ad13","971":"9ee311d8"}[chunkId] + ".chunk.js";
};